/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

// Account Registration form mappings
$(document).ready(function () {
  if ($('#pc-lookup').length) {
    const registrationFields = [
      { element: 'pc-lookup', field: '', mode: pca.fieldMode.SEARCH },
      {
        element: 'CustomerAddress_EstablishmentName',
        field: 'Company',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'CustomerAddress_BuildingName',
        field: 'BuildingName',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'CustomerAddress_Street',
        field: 'Street',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'CustomerAddress_District',
        field: 'District',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'CustomerAddress_Postcode',
        field: 'PostalCode',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'CustomerAddress_TownCity',
        field: 'City',
        mode: pca.fieldMode.POPULATE
      }
    ];
    const accountRegistrationFormControl = new pca.Address(
      registrationFields,
      pcaOptions
    );
    accountRegistrationFormControl.listen(
      'prepopulate',
      function (address, details) {
        console.log(address);
        address = populateFields(address);
      }
    );
  }
});

$(document).ready(function () {
  // Contact us form mappings
  if ($('.contact-us-form').length) {
    const contactUsFields = [
      { element: 'contact-us-search', field: '', mode: pca.fieldMode.SEARCH },
      {
        element: 'contact-us-address',
        field: 'Label',
        mode: pca.fieldMode.POPULATE
      }
    ];
    const contactUsFormControl = new pca.Address(contactUsFields, pcaOptions);
  }
});

$(document).ready(function () {
  if ($('#profileDeliveryAddressForm').length) {
    const profileDeliveryAddressFormFields = [
      {
        element: 'AddNewAddressForm_Postcode',
        field: 'PostalCode',
        mode: pca.fieldMode.DEFAULT | pca.fieldMode.PRESERVE
      },
      {
        element: 'AddNewAddressForm_EstablishmentName',
        field: 'Company',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'AddNewAddressForm_BuildingName',
        field: 'BuildingName',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'AddNewAddressForm_Street',
        field: 'Street',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'AddNewAddressForm_District',
        field: 'District',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'AddNewAddressForm_TownCity',
        field: 'City',
        mode: pca.fieldMode.POPULATE
      }
    ];
    const profileDeliveryAddressFormControl = new pca.Address(
      profileDeliveryAddressFormFields,
      pcaOptions
    );

    profileDeliveryAddressFormControl.listen(
      'prepopulate',
      function (address, details) {
        address = populateFields(address);
      }
    );

    $('body').on('click', '.js-radio-input', function () {
      if (this.id == 'new-address') {
        profileDeliveryAddressFormControl.load();
      }
    });
  }
});

$(document).ready(function () {
  if ($('#registration-address-form').length) {
    const profileDeliveryAddressFormFields = [
      {
        element: 'NewAddressForm_Postcode',
        field: 'PostalCode',
        mode: pca.fieldMode.DEFAULT | pca.fieldMode.PRESERVE
      },
      {
        element: 'NewAddressForm_EstablishmentName',
        field: 'Company',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'NewAddressForm_BuildingName',
        field: 'BuildingName',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'NewAddressForm_Street',
        field: 'Street',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'NewAddressForm_District',
        field: 'District',
        mode: pca.fieldMode.POPULATE
      },
      {
        element: 'NewAddressForm_TownCity',
        field: 'City',
        mode: pca.fieldMode.POPULATE
      }
    ];
    const profileDeliveryAddressFormControl = new pca.Address(
      profileDeliveryAddressFormFields,
      pcaOptions
    );

    profileDeliveryAddressFormControl.listen(
      'prepopulate',
      function (address, details) {
        address = populateFields(address);
      }
    );

    /* Fix for re-validating Postcode field on focus lose */
    $('body').on('blur', '#NewAddressForm_Postcode', function () {
      this.value = this.value.trim();
      $('#NewAddressForm_Postcode').valid();
    });

    $('body').on('click', '.js-radio-input', function () {
      if (this.id == 'new-address') {
        profileDeliveryAddressFormControl.load();
      }
    });
  }
});

function populateFields(address) {
  if (
    address.BuildingName.length > 0 ||
    address.SubBuilding.length > 0 ||
    address.BuildingNumber.length
  ) {
    const buildingName = [
      address.BuildingNumber,
      address.SubBuilding,
      address.BuildingName
    ]
      .filter((item) => item && item.length > 0)
      .join(', ');
    address.BuildingName = buildingName;
  }
}
